import { render } from "./NewsView.vue?vue&type=template&id=67c7a466&ts=true"
import script from "./NewsView.vue?vue&type=script&lang=ts"
export * from "./NewsView.vue?vue&type=script&lang=ts"

import "./NewsView.vue?vue&type=style&index=0&id=67c7a466&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__